import { Component } from 'react';
import { Input, Button, Form } from 'antd';
import { Helmet } from 'react-helmet';
import { ConnectedProps, connect } from 'react-redux';
import { RootState } from 'src/redux/store';
import styles from './style.module.scss';

const connector = connect(({ user }: RootState) => ({ user }));
interface NewPasswordProps extends ConnectedProps<typeof connector> {}

class PasswordChangeForm extends Component<NewPasswordProps> {
  onSubmit = (values: any) => {
    const { dispatch } = this.props;
    dispatch({
      type: 'user/CHANGE_PASSWORD',
      payload: values,
    });
  };

  render() {
    const {
      user: { loading },
    } = this.props;
    return (
      <div>
        <Helmet title="New Password" />
        <div className={`${styles.title} login-heading`}>
          <h1>
            <strong>WELCOME TO WAHED INVEST</strong>
          </h1>
          <h4>
            <strong>KYC Dashboard</strong>
          </h4>
        </div>
        <div className={styles.block}>
          <div className="row">
            <div className="col-xl-12">
              <div className={styles.inner}>
                <div className={styles.form}>
                  <h4 className="text-uppercase">
                    <strong>Change Password</strong>
                  </h4>
                  <br />
                  <Form layout="vertical" requiredMark={false} onFinish={this.onSubmit}>
                    <Form.Item
                      label="New Password"
                      rules={[{ required: true, message: 'Please input your new password' }]}
                    >
                      <Input type="password" />
                    </Form.Item>
                    <div className="form-actions">
                      <Button
                        type="primary"
                        className="width-150 mx-auto"
                        htmlType="submit"
                        loading={loading}
                      >
                        Change Password
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const NewPassword = connector(PasswordChangeForm);
